export default __webpack_public_path__ + "static/media/simple-paying.c20ad3de.svg";